<template>
    <div>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="800"
        >
            <!-- <template v-slot:activator="{ on, attrs }">
                <v-list-item
                    v-if="tipo=='listItem'"
                    v-bind="attrs"                    
                    v-on="on"
                >
                    <v-list-item-icon class="mr-2">
                        <v-icon>mdi-eye</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Visualizar</v-list-item-title>
                </v-list-item>
            </template> -->
            <v-card class="text-center pb-2">
                <v-card-title>
                    <span class="text-h6">                    
                        {{ file == null ? '' : file.name }}
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col
                                cols="12"
                            >
                                <iframe
                                    :src="fileURL ? fileURL : ''"
                                    frameborder="0"
                                    width="100%"
                                    height="600px"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        depressed
                        rounded
                        @click="closeDialog"
                    >
                        Cerrar
                    </v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
        

       

        <v-snackbar
            key="snackbarDialogVisualizarArchivo"
            v-model="snackbar"
            :bottom="true"
            :multi-line="true"
            :color="snackbarColor"
        >
            {{ snackbarTexto }}
            <v-btn
                dark
                text
                @click="snackbar = false;"
            >
                Cerrar
            </v-btn>
        </v-snackbar> 
    </div>
</template>

<script>

export default {
  name: "DialogVisualizarArchivo",
  components: {
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    file: {
        type: File,
        default: null
    },
    closeDialog: {
        type: Function,
        required: true
    },
  },
  data () {
    return {
        fileURL: '',
      loading: false,
      snackbar: false,
      snackbarColor: '',
      snackbarTexto: '',      
    };
  },
  computed: { 
  },
  watch: {
    dialog: {
      handler (newValue, oldValue) {
          this.fileURL = URL.createObjectURL(this.file);
      }
    }
  },
  async mounted () {
  },
  methods: {
    }
};
</script>